import React, { useState } from "react";
//--------Material React Table------//
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table"; //material-react-table
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import html2pdf from "html2pdf.js";
import Loader from "../Loader/Loader";

function CommonMatrialReactTable({
  columns,
  data,
  MainHeading,
  ReportHeading,
  startdate,
  enddate,
  columnGrouping,
  setColumnOrder,
  setColumnVisibility,
  state,
  columnPinning = {},
  hodiExport = false,
  isItemInventory = false,
  isdriverdailyreport = false,
}) {
  const [loading, setLoading] = useState(false);

  const onBtExport = (filterData, field) => {
    const workbook = XLSX.utils.book_new();

    let Data = [];

    console.log(data, "787");
    
    if (field === "AllData") {
      Data = data.map(el => ({
        ...el, // Spread all other properties of the object
        Date: moment(el.Date).format("MM-DD-YYYY") // Format the Date field
      }));
    } else {
      Data = filterData?.map((el) => el?.original);
    }
    
    console.log(Data, "export pdf data");
    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(Data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `Exel_Report.xlsx`);
  };

  const downloadPDF = (rows, field, visibleColumns) => {
    console.log("visibleColumns=>", visibleColumns);
    let reportMainHeading = MainHeading;
    let reportHeading = ReportHeading;
    let reportDateHeading =
      startdate && enddate ? `From: ${startdate} To: ${enddate}` : "All Date";

    visibleColumns = visibleColumns.filter(
      (col) => col.columnDef.header !== "Select"
    );

    let newData = [];
    if (field === "selectedrow") {
      newData = rows.map((row) => row.original);
    } else if (field === "alldata") {
      newData = data.map((el) => {
        return {
          ...el,
          OpenBalance:
            el.OpenBalance == null || el.OpenBalance === "NaN"
              ? ""
              : parseFloat(el.OpenBalance),
          ModifiedBy: el.ModifiedBy == null ? "" : el.ModifiedBy,
          DeliveryAddress: el.DeliveryAddress == null ? "" : el.DeliveryAddress,
        };
      });
    }

    const doc = new jsPDF("p", "mm", "a4");

    let pageWidth = doc.internal.pageSize.width;
    let pageHeight = doc.internal.pageSize.height;

    let itemsPerPage = Math.floor(pageHeight); // Adjust the factor based on your content
    console.log("itemsPerPage=>", itemsPerPage);

    doc.setFontSize(10);

    for (
      let currentPage = 1, rowNumber = 1;
      rowNumber <= newData.length;
      currentPage++
    ) {
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = Math.min(currentPage * itemsPerPage, newData.length);

      // Dynamic header
      const header = [
        "No",
        ...visibleColumns.map((col) => col.columnDef.header),
      ];

      // Extract data for the current page
      const pageData = newData.slice(startIndex, endIndex);

      // Calculate header height
      const headerHeight = doc.getTextDimensions(header.join(" ")).h + 2;

      // Calculate startY for the first page, and for subsequent pages, consider header height
      const startY = currentPage === 1 ? 25 : headerHeight; // Adjust as needed

      // Build the table content
      const content = {
        startY: startY,
        head: [header],
        body: pageData.map((row) => {
          // Parse row data dynamically
          const parsedRow = visibleColumns.map((col) => {
            const dataValue = row[col.columnDef.id];
            let value = "";

            if (typeof dataValue === "number") {
              value = parseFloat(dataValue);
            } else if (typeof dataValue === "string") {
              value = dataValue;
            } else if (moment(dataValue).isValid()) {
              value = moment(dataValue).format("MM-DD-YYYY (HH:mm)");
            }

            return value;
          });

          return [rowNumber++, ...parsedRow];
        }),
        headStyles: { fillColor: [100, 100, 100] },
      };

      // Add the header on every page
      let textWidth =
        (doc.getStringUnitWidth(reportMainHeading) *
          doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      let centerX = (pageWidth - textWidth) / 2;
      doc.text(reportMainHeading, centerX, 10);

      let textWidthHeading =
        (doc.getStringUnitWidth(reportHeading) * doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      let centerXHeading = (pageWidth - textWidthHeading) / 2;
      doc.text(reportHeading, centerXHeading, 15);

      let textWidthDate =
        (doc.getStringUnitWidth(reportDateHeading) *
          doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      let centerXDate = (pageWidth - textWidthDate) / 2;
      doc.text(reportDateHeading, centerXDate, 20);

      doc.setPage(currentPage);
      doc.autoTable(content);

      // Add page break if not the last page
      if (currentPage < Math.ceil(newData.length / itemsPerPage)) {
        doc.addPage();
      }
    }

    doc.save(`${ReportHeading}.pdf`);
  };

  const handlePrint = (rows, field, visibleColumns) => {
    setLoading(true);
    console.log("visibleColumns=>", visibleColumns);
    let reportMainHeading = MainHeading;
    let reportHeading = ReportHeading;
    let reportDateHeading =
      startdate && enddate
        ? `From: ${startdate} To: ${enddate}`
        : isItemInventory
        ? moment().format("MM/DD/YYYY hh:mm a")
        : "All Date";

    visibleColumns = visibleColumns.filter(
      (col) => col.columnDef.header !== "Select"
    );

    let newData = [];
    if (field === "selectedrow") {
      newData = rows.map((row) => row.original);
    } else if (field === "alldata") {
      newData = data.map((el) => {
        return {
          ...el,
          OpenBalance:
            el.OpenBalance == null || el.OpenBalance === "NaN"
              ? ""
              : parseFloat(el.OpenBalance),
          ModifiedBy: el.ModifiedBy == null ? "" : el.ModifiedBy,
          DeliveryAddress: el.DeliveryAddress == null ? "" : el.DeliveryAddress,
        };
      });
    }

    const doc = new jsPDF("p", "mm", "a4");

    let pageWidth = doc.internal.pageSize.width;
    let pageHeight = doc.internal.pageSize.height;

    let itemsPerPage = Math.floor(pageHeight); // Adjust the factor based on your content
    console.log("itemsPerPage=>", itemsPerPage);

    doc.setFontSize(10);

    for (
      let currentPage = 1, rowNumber = 1;
      rowNumber <= newData.length;
      currentPage++
    ) {
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = Math.min(currentPage * itemsPerPage, newData.length);

      // Dynamic header
      const header = [
        "No",
        ...visibleColumns.map((col) => col.columnDef.header),
      ];

      // Extract data for the current page
      const pageData = newData.slice(startIndex, endIndex);

      // Calculate header height
      const headerHeight = doc.getTextDimensions(header.join(" ")).h + 2;

      // Calculate startY for the first page, and for subsequent pages, consider header height
      const startY = currentPage === 1 ? 25 : headerHeight; // Adjust as needed

      // Build the table content
      const content = {
        startY: startY,
        head: [header],
        body: pageData.map((row) => {
          // Parse row data dynamically
          const parsedRow = visibleColumns.map((col) => {
            const dataValue = row[col.columnDef.id];
            let value = "";

            if (typeof dataValue === "number") {
              value = parseFloat(dataValue);
            } else if (typeof dataValue === "string") {
              value = dataValue;
            } else if (moment(dataValue).isValid()) {
              value = moment(dataValue).format("MM/DD/YYYY (HH:mm)");
            }

            return value;
          });

          return [rowNumber++, ...parsedRow];
        }),
        headStyles: { fillColor: [100, 100, 100] },
      };

      // Add the header on every page
      let textWidth =
        (doc.getStringUnitWidth(reportMainHeading) *
          doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      let centerX = (pageWidth - textWidth) / 2;
      // doc.text(reportMainHeading, centerX, 10);

      let textWidthHeading =
        (doc.getStringUnitWidth(reportHeading) * doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      let centerXHeading = (pageWidth - textWidthHeading) / 2;
      // doc.text(reportHeading, centerXHeading, 15);

      let textWidthDate =
        (doc.getStringUnitWidth(reportDateHeading) *
          doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      let centerXDate = (pageWidth - textWidthDate) / 2;
      doc.text(reportDateHeading, centerXDate, 10);

      doc.setPage(currentPage);
      doc.autoTable(content);

      // Add page break if not the last page
      if (currentPage < Math.ceil(newData.length / itemsPerPage)) {
        doc.addPage();
      }
    }

    doc.save(`${ReportHeading}.pdf`);
    setLoading(false);
  };

  // const handlePrintbyID = () => {
  //   setTimeout(() => {
  //     // Select the print container element
  //     let printContainer = document.querySelector("#PrintTable");

  //     if (!printContainer) {
  //       console.error("PrintTable element not found");
  //       return;
  //     }

  //     console.log(printContainer, "7881414");

  //     // Clone the print container content into a new table
  //     let table = document.createElement("table");
  //     table.className = "table mt-1";
  //     table.style.width = "100%"; // Ensure table width is set to 100%
  //     table.style.borderCollapse = "collapse"; // Optional: to remove gaps between cells

  //     // Clone the inner HTML of the print container and append it to the table
  //     table.appendChild(printContainer.cloneNode(true));

  //     // Apply styles to prevent content from being cut off
  //     table.style.overflowX = "auto"; // Add scroll if content overflows

  //     // Define options for html2pdf
  //     const opt = {
  //       margin: 0.2,
  //       filename: `Invoice.pdf`,
  //       html2canvas: {
  //         scale: 3, // Higher scale for better resolution
  //         useCORS: true, // Enable CORS to allow cross-origin images
  //         logging: true, // Enable logging for debugging
  //         windowWidth: printContainer.scrollWidth, // Capture the full width of the content
  //         windowHeight: printContainer.scrollHeight, // Capture the full height of the content
  //       },
  //       jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
  //     };

  //     // Generate PDF using html2pdf
  //     html2pdf()
  //       .from(table)
  //       .set(opt)
  //       .output("blob")
  //       .then((pdfBlob) => {
  //         const pdfUrl = URL.createObjectURL(pdfBlob); // Create a URL for the Blob
  //         window.open(pdfUrl, "_blank"); // Open the PDF in a new tab
  //       })
  //       .catch((err) => {
  //         console.error("Error generating PDF:", err);
  //       });
  //   }, 50);
  // };

  const handlePrintbyID1 = () => {
    let printContainer = document.createElement("div");

    const Items = data || [];
    const itemsPerPage = 18;
    const firstPageItemsCount = 13;
    const specialFirstPageItemsCount = 8;
    const totalItems = data.length;
    let carryOverSum = 0;
    let currentIndex = 1;

    const chunkArray = (array, specialCase) => {
      const chunks = [];
      if (specialCase) {
        if (array.length > specialFirstPageItemsCount) {
          chunks.push(array.slice(0, specialFirstPageItemsCount));
          chunks.push(array.slice(specialFirstPageItemsCount));
        } else {
          chunks.push(array);
        }
      } else {
        if (array.length > 0) {
          chunks.push(array.slice(0, firstPageItemsCount));
        }
        for (let i = firstPageItemsCount; i < array.length; i += itemsPerPage) {
          chunks.push(array.slice(i, i + itemsPerPage));
        }
      }
      return chunks;
    };

    const chunks = chunkArray(Items, totalItems >= 7 && totalItems <= 14);

    chunks.forEach((chunk, pageIndex) => {
      let page = document.createElement("div");
      page.style.pageBreakAfter = "always";

      let table = document.createElement("table");
  
      let thead = document.createElement("thead");
      thead.innerHTML = `<tr>
          <th style="padding: 7px; border: 1px solid #dcdcdc; text-align: left;">Item Id</th>
          <th style="padding: 7px; border: 1px solid #dcdcdc; text-align: left;">Name</th>
          <th style="padding: 7px; border: 1px solid #dcdcdc; text-align: left;">Category</th>
          <th style="padding: 7px; border: 1px solid #dcdcdc; text-align: left;">Product Id</th>
          <th style="padding: 7px; border: 1px solid #dcdcdc; text-align: left;">Item Number</th>
          <th style="padding: 7px; border: 1px solid #dcdcdc; text-align: left;">Supplier</th>
          <th style="padding: 7px; border: 1px solid #dcdcdc; text-align: left;">Qty</th>
        </tr>`;
  
      let tbody = document.createElement("tbody");

      chunk.forEach((item, index) => {
        let row = document.createElement("tr");
      
        tbody.innerHTML = `
          <tr>
            <td style="border: 1px solid #dcdcdc; padding: 7px;">${item.ItemId}</td>
            <td style="border: 1px solid #dcdcdc; padding: 7px;">${item.Name}</td>
            <td style="border: 1px solid #dcdcdc; padding: 7px;">${item.Category}</td>
            <td style="border: 1px solid #dcdcdc; padding: 7px;">${item.ProductId}</td>
            <td style="border: 1px solid #dcdcdc; padding: 7px;">${item.ItemNumber}</td>
            <td style="border: 1px solid #dcdcdc; padding: 7px;">${item.Supplier}</td>
            <td style="border: 1px solid #dcdcdc; padding: 7px;">${item.Quantity}</td>
          </tr>`

          tbody.appendChild(row);
      
      })

      table.appendChild(thead);
      table.appendChild(tbody);
      
      page.appendChild(table);
      printContainer.appendChild(page);


    });


    // Delayed PDF generation for better rendering
    setTimeout(() => {
      const opt = {
        margin: 0.2,
        filename: `InventoryPrint.pdf`, // "SaleInvoice.pdf",
        html2canvas: { scale: 4 }, // Increase the scale for better resolution
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };
      html2pdf()
        .from(printContainer)
        .set(opt)
        .save()
        .then((pdf) => {
          console.log("PDF data exported:", pdf);
        });
    }, 50);
  };

  const handlePrintbyID = () => {
    let printContainer = document.createElement("div");
  
    // Sample data array or fallback to an empty array
    const Items = data || [];
    const itemsPerPage = 14;
    const firstPageItemsCount = 14;
    const specialFirstPageItemsCount = 8;
    const totalItems = Items.length;
    let currentIndex = 1;
  
    // Function to split the array into chunks for pagination
    const chunkArray = (array, specialCase) => {
      const chunks = [];
      // if (specialCase) {
      //   if (array.length > specialFirstPageItemsCount) {
      //     chunks.push(array.slice(0, specialFirstPageItemsCount));
      //     chunks.push(array.slice(specialFirstPageItemsCount));
      //   } else {
      //     chunks.push(array);
      //   }
      // } else {
        if (array.length > 0) {
          chunks.push(array.slice(0, firstPageItemsCount));
        }
        for (let i = firstPageItemsCount; i < array.length; i += itemsPerPage) {
          chunks.push(array.slice(i, i + itemsPerPage));
        }
      // }
      return chunks;
    };
  
    // Determine if a special case of pagination is needed
    const chunks = chunkArray(Items
      // , totalItems >= 7 && totalItems <= 14
    );
  
    // Iterate over each chunk (page)
    chunks.forEach((chunk, pageIndex) => {
      // Create a new page
      let page = document.createElement("div");
      page.style.pageBreakAfter = "always";
  
      // Create the table and its header
      let table = document.createElement("table");
      let thead = document.createElement("thead");

      // <th style="padding: 7px; border: 1px solid #dcdcdc; text-align: left;">Product Id</th>
      thead.innerHTML = `<tr>
          <th style="padding: 7px; border: 1px solid #dcdcdc; text-align: left;">Item Id</th>
          <th style="padding: 7px; border: 1px solid #dcdcdc; text-align: left;">Name</th>
          <th style="padding: 7px; border: 1px solid #dcdcdc; text-align: left;">Category</th>
          <th style="padding: 7px; border: 1px solid #dcdcdc; text-align: left;">Item Number</th>
          <th style="padding: 7px; border: 1px solid #dcdcdc; text-align: left;">Qty</th>
          <th style="padding: 7px; border: 1px solid #dcdcdc; text-align: left; width: 50px;">    </th>
        </tr>`;
  
      // Create the table body
      let tbody = document.createElement("tbody");
  
      // Populate the table body with rows from the current chunk
      chunk.forEach((item) => {
        let row = document.createElement("tr");
        // <td style="border: 1px solid #dcdcdc; padding: 7px;">${item.ProductId || '-'}</td>
        row.innerHTML = `
          <td style="border: 1px solid #dcdcdc; padding: 7px;">${item.ItemId}</td>
          <td style="border: 1px solid #dcdcdc; padding: 7px;">${item.Name}</td>
          <td style="border: 1px solid #dcdcdc; padding: 7px;">${item.Category}</td>
          <td style="border: 1px solid #dcdcdc; padding: 7px;">${item.ItemNumber || '-'}</td>
          <td style="border: 1px solid #dcdcdc; padding: 7px;">${item.Quantity}</td>
          <td style="border: 1px solid #dcdcdc; padding: 7px; width: 50px;"></td>
        `;
        // Append each row to the table body
        tbody.appendChild(row);
      });
  
      // Append the table head and body to the table
      table.appendChild(thead);
      table.appendChild(tbody);
  
      // Append the table to the page
      let p = document.createElement("p");
       p.innerHTML = `<p>Date: ${moment().format('MM/DD/YYYY hh:mm a')}</p>`

      page.appendChild(p);
      page.appendChild(table);
      printContainer.appendChild(page);
    });
  
    // Delayed PDF generation for better rendering
    setTimeout(() => {
      const opt = {
        margin: 0.2,
        filename: `InventoryPrint.pdf`,
        html2canvas: { scale: 4 }, // Increase the scale for better resolution
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };
      html2pdf()
        .from(printContainer)
        .set(opt)
        .save()
        .then((pdf) => {
          console.log("PDF data exported:", pdf);
        });
    }, 50);
  };
  


  const handlePrintbydata = () => {
    let printContainer = document.createElement("div");
  
    // Sample data array or fallback to an empty array
    const Items = data || [];
    const itemsPerPage = 18;
    const firstPageItemsCount = 18;
    const specialFirstPageItemsCount = 8;
    const totalItems = Items.length;
    let currentIndex = 1;
  
    // Function to split the array into chunks for pagination
    const chunkArray = (array, specialCase) => {
      const chunks = [];
      // if (specialCase) {
      //   if (array.length > specialFirstPageItemsCount) {
      //     chunks.push(array.slice(0, specialFirstPageItemsCount));
      //     chunks.push(array.slice(specialFirstPageItemsCount));
      //   } else {
      //     chunks.push(array);
      //   }
      // } else {
        if (array.length > 0) {
          chunks.push(array.slice(0, firstPageItemsCount));
        }
        for (let i = firstPageItemsCount; i < array.length; i += itemsPerPage) {
          chunks.push(array.slice(i, i + itemsPerPage));
        }
      // }
      return chunks;
    };
  
    // Determine if a special case of pagination is needed
    const chunks = chunkArray(Items
      // , totalItems >= 7 && totalItems <= 14
    );
  
    // Iterate over each chunk (page)
    chunks.forEach((chunk, pageIndex) => {
      // Create a new page
      let page = document.createElement("div");
      page.style.pageBreakAfter = "always";
  
      // Create the table and its header
      let table = document.createElement("table");
      let thead = document.createElement("thead");

      // <th style="padding: 7px; border: 1px solid #dcdcdc; text-align: left;">Product Id</th>
      thead.innerHTML = `<tr>
          <th style="padding: 7px; border: 1px solid #dcdcdc; text-align: left;">Date</th>
          <th style="padding: 7px; border: 1px solid #dcdcdc; text-align: left;">Sale Type</th>
          <th style="padding: 7px; border: 1px solid #dcdcdc; text-align: left;">Invoice #</th>
             <th style="padding: 7px; border: 1px solid #dcdcdc; text-align: left;">Company Name #</th>
          <th style="padding: 7px; border: 1px solid #dcdcdc; text-align: left;">Total</th>
          <th style="padding: 7px; border: 1px solid #dcdcdc; text-align: left;">Delivery Status</th>
          <th style="padding: 7px; border: 1px solid #dcdcdc; text-align: left;">  Route  </th>
        </tr>`;
  
      // Create the table body
      let tbody = document.createElement("tbody");
  
      // Populate the table body with rows from the current chunk
      chunk.forEach((item) => {
        let row = document.createElement("tr");
        // <td style="border: 1px solid #dcdcdc; padding: 7px;">${item.ProductId || '-'}</td>
        row.innerHTML = `
          <td style="border: 1px solid #dcdcdc; padding: 7px;">${moment(item.Date).format("MM/DD/YYYY ")}</td>
          <td style="border: 1px solid #dcdcdc; padding: 7px;">${item.SaleType}</td>
          <td style="border: 1px solid #dcdcdc; padding: 7px;">${item.ID}</td>
          <td style="border: 1px solid #dcdcdc; padding: 7px;">${item.CompanyName || '-'}</td>
          <td style="border: 1px solid #dcdcdc; padding: 7px;">${item.Total}</td>
          <td style="border: 1px solid #dcdcdc; padding: 7px; width: 50px;"></td>
          <td style="border: 1px solid #dcdcdc; padding: 7px; width: 50px;"></td>
        `;
        // Append each row to the table body
        tbody.appendChild(row);
      });
  
      // Append the table head and body to the table
      table.appendChild(thead);
      table.appendChild(tbody);
  
      // Append the table to the page
      let p = document.createElement("p");
       p.innerHTML = `<p>Date: ${moment().format('MM/DD/YYYY hh:mm a')}</p>`

      page.appendChild(p);
      page.appendChild(table);
      printContainer.appendChild(page);
    });
  
    // Delayed PDF generation for better rendering
    setTimeout(() => {
      const opt = {
        margin: 0.2,
        filename: `DriverDailyPrint.pdf`,
        html2canvas: { scale: 4 }, // Increase the scale for better resolution
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };
      html2pdf()
        .from(printContainer)
        .set(opt)
        .save()
        .then((pdf) => {
          console.log("PDF data exported:", pdf);
        });
    }, 50);
  };
  //handlePrintbyID

  const table = useMaterialReactTable({
    columns,
    data,
    enableRowSelection: true, //table options as options to this hook
    // enableColumnResizing: true,
    enableGrouping: true,
    enableStickyHeader: true,
    enableStickyFooter: true,
    enableRowSelection: isItemInventory || isdriverdailyreport ? false : true,
    enableColumnOrdering: true,
    enableColumnPinning: true,
    sortDescFirst: true,
    enableColumnFilterModes: true,
    enablePagination: true,
    ...(setColumnOrder ? {
    onColumnOrderChange: setColumnOrder}:{}),
    // onColumnVisibilityChange: setColumnVisibility,
    muiTableBodyProps: {
      sx: () => ({
        "& tr:nth-of-type(even)": {
          backgroundColor: "var(--datatable-row-background-color)",
          //'rgb(237 237 233 / 63%)'
        },
        "& td": {
          borderRight: "1px solid var(--datatable-row-background-hover-color)",
          lineHeight: "16px",
          fontWeight: "400",
          fontSize: "12px",
          color: "var(--primary-color-800)",
          fontFamily: "Inter",
        },

        "& tr": {
          lineHeight: "16px",
          fontWeight: "400",
          fontSize: "12px",
          color: "var(--primary-color-800)",
          fontFamily: "Inter",
        },
      }),
    },
    muiTableHeadCellProps: {
      sx: (theme) => ({
        background: "var(--datatable-row-background-color)", //'#e9e9e9',
        borderRight: "1px solid var(--datatable-row-background-hover-color)",
        lineHeight: "16px",
        fontWeight: "500",
        fontSize: "14px",
        color: "var(--primary-color-800)",
        fontFamily: "Inter",
      }),
    },
    muiToolbarAlertBannerProps: {
      isError: () => ({
        color: "error",
        children: "Error loading data",
      }),
      sx: (theme) => ({
        background: "var(--datatable-row-background-color)", //'#e9e9e9',
        lineHeight: "16px",
        fontWeight: "500",
        fontSize: "14px",
        color: "var(--primary-color-800)",
        fontFamily: "Inter",
      }),
    },
    muiSelectCheckboxProps: {
      sx: (theme) => ({
        lineHeight: "16px",
        fontWeight: "400",
        fontSize: "12px",
        color: "var(--prinary-color-800)",
        fontFamily: "Inter",
      }),
    },
    muiSelectAllCheckboxProps: {
      sx: (theme) => ({
        lineHeight: "16px",
        fontWeight: "400",
        fontSize: "12px",
        color: "var(--prinary-color-800)",
        fontFamily: "Inter",
      }),
    },
    muiTableContainerProps: { sx: { maxHeight: "fit-content" } },
    muiPaginationProps: {
      rowsPerPageOptions: [50, 100, 300, 500, 1000],
    },
    initialState: {
      density: "compact",
      expanded: true, //expand all groups by default
      grouping: columnGrouping, //an array of columns to group by by default (can be multiple)
      pagination: { pageIndex: 0, pageSize: 50 },
      showColumnFilters: false,
      columnPinning: columnPinning, // simple format for left and right { left: ['CustomerName'], right: ['SyncStatusName'] }
      // columnVisibility: columnsVisibility,
      // sorting: { id: "Name", desc: false }, //sort by state by default
    },
    state: state,

    renderTopToolbarCustomActions: ({ table }) =>
      !hodiExport &&
      (isItemInventory ? (
        <Box
          sx={{
            display: "flex",
            gap: "1rem",
            p: "0.5rem",
            flexWrap: "wrap",
          }}
        >
          <Button
            // size="small"
            className="btn btn-sm btn-secondary"
            style={{ display: "flex" }}
            color="primary"
            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
            onClick={() => onBtExport([], "AllData")}
            startIcon={<FileDownloadIcon />}
            variant="contained"
            disabled={data?.length === 0}
          >
            Export All In Excel
          </Button>
          <Button
            // size="small"
            class="btn btn-sm btn-secondary"
            style={{ display: "flex" }}
            color="primary"
            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
            onClick={() =>
              // handlePrint("", "alldata", table.getVisibleFlatColumns())
              handlePrintbyID("", "alldata", table.getVisibleFlatColumns())
            }
            startIcon={<FileDownloadIcon />}
            variant="contained"
            disabled={data?.length === 0}
          >
            EXPORT ALL IN PDF
          </Button>
        </Box>
      ) : isdriverdailyreport ? (   <Box
        sx={{
          display: "flex",
          gap: "1rem",
          p: "0.5rem",
          flexWrap: "wrap",
        }}
      >
        <Button
          // size="small"
          className="btn btn-sm btn-secondary"
          style={{ display: "flex" }}
          color="primary"
          //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
          onClick={() => onBtExport([], "AllData")}
          startIcon={<FileDownloadIcon />}
          variant="contained"
          disabled={data?.length === 0}
        >
          Export All In Excel
        </Button>
        <Button
          // size="small"
          class="btn btn-sm btn-secondary"
          style={{ display: "flex" }}
          color="primary"
          //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
          onClick={() =>
            // handlePrint("", "alldata", table.getVisibleFlatColumns())
            handlePrintbydata("", "alldata", table.getVisibleFlatColumns())
          }
          startIcon={<FileDownloadIcon />}
          variant="contained"
          disabled={data?.length === 0}
        >
          EXPORT ALL IN PDF
        </Button>
      </Box>) : (
        <Box
          sx={{
            display: "flex",
            gap: "1rem",
            p: "0.5rem",
            flexWrap: "wrap",
          }}
        >
          <Button
            // size="small"
            className="btn btn-sm btn-secondary"
            style={{ display: "flex" }}
            color="primary"
            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
            onClick={() => onBtExport([], "AllData")}
            startIcon={<FileDownloadIcon />}
            variant="contained"
          >
            Export All In Excel
          </Button>
          <Button
            // size="small"
            class="btn btn-sm btn-secondary"
            style={{ display: "flex" }}
            color="primary"
            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
            onClick={() =>
              downloadPDF("", "alldata", table.getVisibleFlatColumns())
            }
            startIcon={<FileDownloadIcon />}
            variant="contained"
          >
            EXPORT ALL IN PDF
          </Button>
          <Button
            // size="small"
            className="btn btn-sm btn-secondary"
            style={{ display: "flex" }}
            color="primary"
            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
            onClick={() => onBtExport(table.getSelectedRowModel().rows, "")}
            startIcon={<FileDownloadIcon />}
            variant="contained"
            disabled={
              !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
            }
          >
            EXPORT SELECTED ROWS IN EXCEL
          </Button>
          <Button
            // size="small"
            class="btn btn-sm btn-secondary"
            style={{ display: "flex" }}
            disabled={
              !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
            }
            //only export selected rows
            onClick={() =>
              downloadPDF(
                table.getSelectedRowModel().rows,
                "selectedrow",
                table.getVisibleFlatColumns()
              )
            }
            startIcon={<FileDownloadIcon />}
            variant="contained"
          >
            EXPORT SELECTED ROWS IN PDF
          </Button>
          <Button
            // size="small"
            className="btn btn-sm btn-secondary"
            style={{ display: "flex" }}
            color="primary"
            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
            onClick={() => onBtExport(table.getRowModel().rows, "")}
            startIcon={<FileDownloadIcon />}
            variant="contained"
          >
            Export Page Rows In Excel
          </Button>
          <Button
            disabled={table.getRowModel().rows.length === 0}
            //export all rows as seen on the screen (respects pagination, sorting, filtering, etc.)
            onClick={() =>
              downloadPDF(
                table.getRowModel().rows,
                "selectedrow",
                table.getVisibleFlatColumns()
              )
            }
            class="btn btn-sm btn-secondary"
            style={{ display: "flex" }}
            variant="contained"
            startIcon={<FileDownloadIcon />}
          >
            Export Page Rows In Pdf
          </Button>
        </Box>
      )),
  });

  console.log(columns, data, "Ashish");

  return (
    <>
      <Loader loading={loading} />
      {/* <div id="PrintTable"> */}
      <MaterialReactTable
        table={table} //only pass in table instead of all table options
      />
      {/* </div> */}
      {/* <MaterialReactTable
        columns={columns}
        data={data}
        // positionPagination='top'
        enableColumnResizing
        enableGrouping
        enableStickyHeader
        enableStickyFooter
        enableRowSelection
        enableColumnOrdering
        sortDescFirst
        enableColumnFilterModes
        enablePagination
        // groupedColumnMode="remove" // remove, reorder, false
        muiTableBodyProps={{
          sx: () => ({
            "& tr:nth-of-type(even)": {
              backgroundColor: "var(--datatable-row-background-color)",
              //'rgb(237 237 233 / 63%)'
            },
            "& td": {
              borderRight:
                "1px solid var(--datatable-row-background-hover-color)",
              lineHeight: "16px",
              fontWeight: "400",
              fontSize: "12px",
              color: "var(--primary-color-800)",
              fontFamily: "Inter",
            },

            "& tr": {
              lineHeight: "16px",
              fontWeight: "400",
              fontSize: "12px",
              color: "var(--primary-color-800)",
              fontFamily: "Inter",
            },
          }),
        }}
        muiTableHeadCellProps={{
          sx: (theme) => ({
            background: "var(--datatable-row-background-color)", //'#e9e9e9',
            borderRight:
              "1px solid var(--datatable-row-background-hover-color)",
            lineHeight: "16px",
            fontWeight: "500",
            fontSize: "14px",
            color: "var(--primary-color-800)",
            fontFamily: "Inter",
          }),
        }}
        muiToolbarAlertBannerProps={
          // isError
          // ? {
          //   color: "error",
          //   children: "Error loading data",
          // }
          // : undefined
          {
            isError: () => ({
              color: "error",
              children: "Error loading data",
            }),
            sx: (theme) => ({
              background: "var(--datatable-row-background-color)", //'#e9e9e9',
              lineHeight: "16px",
              fontWeight: "500",
              fontSize: "14px",
              color: "var(--primary-color-800)",
              fontFamily: "Inter",
            }),
          }
        }
        muiSelectCheckboxProps={{
          sx: (theme) => ({
            lineHeight: "16px",
            fontWeight: "400",
            fontSize: "12px",
            color: "var(--prinary-color-800)",
            fontFamily: "Inter",
          }),
        }}
        muiSelectAllCheckboxProps={{
          sx: (theme) => ({
            lineHeight: "16px",
            fontWeight: "400",
            fontSize: "12px",
            color: "var(--prinary-color-800)",
            fontFamily: "Inter",
          }),
        }}
        muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
        muiPaginationProps={{
          rowsPerPageOptions: [50, 100, 300, 500, 1000, 2000, 5000, 10000],
        }}
        initialState={{
          density: "compact",
          expanded: true, //expand all groups by default
          grouping: columnGrouping, //an array of columns to group by by default (can be multiple)
          pagination: { pageIndex: 0, pageSize: 50 },
          showColumnFilters: true,
          columnVisibility: columnsVisibility,
          // sorting: { id: "Name", desc: false }, //sort by state by default
        }}
        // muiToolbarAlertBannerChipProps={{ color: "primary" }}

        // manualFiltering  // for termp comment filteron column
        // manualPagination
        // manualSorting
        // onColumnFiltersChange={setColumnFilters} // for termp comment filteron column
        // onGlobalFilterChange={setGlobalFilter}
        // onPaginationChange={setPagination}
        // onSortingChange={setSorting}
        // rowCount={rowCount}
        // enableColumnVirtualization={false}
        // rowVirtualizerOptions={{
        //   overscan: 10, //adjust the number or rows that are rendered above and below the visible area of the table
        //   estimateSize: () => 100, //if your rows are taller than normal, try tweaking this value to make scrollbar size more accurate
        // }}
        // enableColumnVirtualization
        // state={{
        //   // columnFilters, // for termp comment filteron column
        //   // globalFilter,
        //   isLoading,
        //   // pagination,
        //   showAlertBanner: isError,
        //   showProgressBars: isRefetching,
        //   // sorting,
        // }}
        renderTopToolbarCustomActions={({ table }) => (
          <Box
            sx={{
              display: "flex",
              gap: "1rem",
              p: "0.5rem",
              flexWrap: "wrap",
            }}
          >
            <Button
              // size="small"
              className="btn btn-sm btn-secondary"
              style={{ display: "flex" }}
              color="primary"
              //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
              onClick={() => onBtExport([], "AllData")}
              startIcon={<FileDownloadIcon />}
              variant="contained"
            >
              Export All In Excel
            </Button>
            <Button
              // size="small"
              class="btn btn-sm btn-secondary"
              style={{ display: "flex" }}
              color="primary"
              //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
              onClick={() =>
                downloadPDF("", "alldata", table.getVisibleFlatColumns())
              }
              startIcon={<FileDownloadIcon />}
              variant="contained"
            >
              EXPORT ALL IN PDF
            </Button>
            <Button
              // size="small"
              className="btn btn-sm btn-secondary"
              style={{ display: "flex" }}
              color="primary"
              //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
              onClick={() => onBtExport(table.getSelectedRowModel().rows, "")}
              startIcon={<FileDownloadIcon />}
              variant="contained"
              disabled={
                !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
              }
            >
              EXPORT SELECTED ROWS IN EXCEL
            </Button>
            <Button
              // size="small"
              class="btn btn-sm btn-secondary"
              style={{ display: "flex" }}
              disabled={
                !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
              }
              //only export selected rows
              onClick={() =>
                downloadPDF(
                  table.getSelectedRowModel().rows,
                  "selectedrow",
                  table.getVisibleFlatColumns()
                )
              }
              startIcon={<FileDownloadIcon />}
              variant="contained"
            >
              EXPORT SELECTED ROWS IN PDF
            </Button>
            <Button
              // size="small"
              className="btn btn-sm btn-secondary"
              style={{ display: "flex" }}
              color="primary"
              //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
              onClick={() => onBtExport(table.getRowModel().rows, "")}
              startIcon={<FileDownloadIcon />}
              variant="contained"
            >
              Export Page Rows In Excel
            </Button>
            <Button
              disabled={table.getRowModel().rows.length === 0}
              //export all rows as seen on the screen (respects pagination, sorting, filtering, etc.)
              onClick={() =>
                downloadPDF(
                  table.getRowModel().rows,
                  "selectedrow",
                  table.getVisibleFlatColumns()
                )
              }
              class="btn btn-sm btn-secondary"
              style={{ display: "flex" }}
              variant="contained"
              startIcon={<FileDownloadIcon />}
            >
              Export Page Rows In Pdf
            </Button>
          </Box>
        )}
      /> */}
    </>
  );
}

export default CommonMatrialReactTable;
